/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReelDeal
 */
export interface ReelDeal {
    /**
     * 
     * @type {number}
     * @memberof ReelDeal
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ReelDeal
     */
    readonly name: string;
}

/**
 * Check if a given object implements the ReelDeal interface.
 */
export function instanceOfReelDeal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ReelDealFromJSON(json: any): ReelDeal {
    return ReelDealFromJSONTyped(json, false);
}

export function ReelDealFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReelDeal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ReelDealToJSON(value?: ReelDeal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

